import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import OurSpecializedServices from "./sections/OurSpecializedServices";
import StressReliefServices from "./sections/StressReliefServices";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <OurSpecializedServices />
      <StressReliefServices />
      <Footer />
    </div>;
}